import React from 'react'
import styled from 'styled-components'

const StyledPageCarouselViewItem = styled.div`
  width: 100%;
  position: absolute;
  overflow: hidden;
  transition: 0.3s ease-in-out;
  top: 0;
`

interface IPageCarouselViewItemProps {
  style?: React.CSSProperties
  children?: React.ReactNode
}

const PageCarouselViewItem: React.FC<IPageCarouselViewItemProps> = ({
  style,
  children,
}) => (
  <StyledPageCarouselViewItem style={style}>
    {children}
  </StyledPageCarouselViewItem>
)

export { PageCarouselViewItem }
